export default __webpack_public_path__ + "static/media/Eina02-LightItalic.b5152596.ttf";